import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
        {...rest}
    >
        {children}
    </motion.div>
);

export const Kicker = ({ children, className = "", dark = false }) => (
    <span
        className={`kicker inline-flex items-center gap-3 ${dark ? "text-neutral-500" : "text-gold"} ${className}`}
    >
        <span className={`h-px w-8 ${dark ? "bg-neutral-400" : "bg-gold"}`} />
        {children}
    </span>
);
